import { scheduleModalsStyle } from './styles';
import { CreateChancel } from 'components';
import React from 'react';
import { Images, useSecondaryModal } from 'utils';
import { useSelector } from 'react-redux';

export const MassCompleteInfo = ({ resetSelected }) => {
    const classes = scheduleModalsStyle();
    const { closeSecondary } = useSecondaryModal();
    const { massRenderInfo } = useSelector((state) => ({
        massRenderInfo: state.appointment.massRenderInfo,
    }));

    const handleDone = () => {
        closeSecondary();
        if (!massRenderInfo?.length) {
            resetSelected();
        }
    };

    return (
        <div className={classes.lockUnlockWrapper}>
            <p className={classes.confirmTitle}>Confirmation</p>
            {massRenderInfo?.length ? (
                <div className={classes.editConfirmModalWornBox}>
                    <div className={classes.confirmModalWornBoxInfo}>
                        <p>
                            <img src={Images.warning} alt="icon" style={{ marginRight: '4px' }} />
                            {'Warning! The following appointments have issues and cannot be rendered.'}
                        </p>
                    </div>
                    <div className={classes.confirmModalWornBoxDates}>
                        {massRenderInfo?.map((i, j) => (
                            <p key={j}>{i?.displayId}</p>
                        ))}
                    </div>
                </div>
            ) : (
                <div className={classes.confirmModalWornBoxDates} style={{ padding: '10px 0 32px' }}>
                    <p>All appointments have been rendered successfully.</p>
                </div>
            )}
            <CreateChancel
                noChancel={true}
                create={'Done'}
                onCreate={handleDone}
                onClose={() => closeSecondary()}
                buttonWidth="100%"
                createButnMargin={'0'}
            />
        </div>
    );
};
